import { apiSpaceUrl } from "utils/urls";

import axios from "axios";

export const postReference = async (spaceUuid, { params, body }) => {
    const { data } = await axios.post(apiSpaceUrl("reference", spaceUuid), body, {
        params: params,
    });
    return data;
};

export const postReferenceAddFromSource = async (spaceUuid, { body }) => {
    const { data } = await axios.post(apiSpaceUrl("referenceAddFromSource", spaceUuid), body);
    return data;
};

export const postBulkReference = async (spaceUuid, body) => {
    const { data } = await axios.post(apiSpaceUrl("reference", spaceUuid) + "/bulk-create", body);
    return data;
};

export const patchReference = async (spaceUuid, body) => {
    let headers = {};
    if (body.file) {
        headers = {
            "Content-Type": "multipart/form-data",
        };
    }
    const { data } = await axios.patch(apiSpaceUrl("reference", spaceUuid) + "/" + body.id, body, {
        headers: headers,
    });
    return data;
};

export const putBibJson = async (spaceUuid, body) => {
    const { data } = await axios.put(apiSpaceUrl("reference", spaceUuid) + "/" + body.id + "/bib-json", body);
    return data;
};

export const getReferences = async (spaceUuid, params) => {
    const { data } = await axios.get(apiSpaceUrl("reference", spaceUuid), { params: params });
    return data;
};

export const getReference = async (spaceUuid, params) => {
    const { data } = await axios.get(apiSpaceUrl("reference", spaceUuid) + "/no/" + params.reference_no);
    return data;
};

export const deleteReference = async (spaceUuid, body) => {
    const { data } = await axios.delete(apiSpaceUrl("reference", spaceUuid) + "/bulk_delete", {
        data: body,
    });

    return data;
};

export const deleteReferencePdfFile = async (spaceUuid, body) => {
    const { data } = await axios.delete(apiSpaceUrl("reference", spaceUuid) + "/file/reference", {
        data: body,
    });

    return data;
};

export const getJsonToBib = async (spaceUuid, body) => {
    const { data } = await axios.post(apiSpaceUrl("reference", spaceUuid) + "/json-to-bib", body);
    return data;
};

export const restartReferenceFileIndexing = async (spaceUuid, reference_file_id) => {
    const { data } = await axios.put(apiSpaceUrl("referenceFile", spaceUuid) + "/indexing-restart", {
        reference_file_id,
    });

    return data;
};

export const getTagRecommendation = async (spaceUuid, body) => {
    const { data } = await axios.post(apiSpaceUrl("tag", spaceUuid) + `/recommend`, body);
    return data;
};

export const getReferenceFilePdf = async (fileUrl) => {
    const apiOrigin = window.location.protocol + "//" + process.env.REACT_APP_API_BASE_URL;
    const resolvedFileUrl = new URL(fileUrl, apiOrigin).href;
    // aws s3 파일 접근 시 전역 auth 헤더가 들어가면 접근이 안되서 직접 fetch 사용
    const response = await fetch(resolvedFileUrl);
    if (!response.ok) {
        throw new Error(`PDF file download failed: ${response.status}`);
    }
    return response.arrayBuffer();
};

export const getReferenceReviewPageLayout = async (spaceUuid, { reference_file_uuid, page }) => {
    const { data } = await axios.get(apiSpaceUrl("referenceReview", spaceUuid) + `/${reference_file_uuid}/layout`, {
        params: { page },
    });
    return data;
};
